export default {
  common: {
    nav: {
      home: "मुख्यपृष्ठ",
      find_offer_help: "मदत शोधा / द्या",
      celebrate: "जीवनाचा उत्सव",
      family_tree: "कुटुंब वृक्ष",
      events: "कार्यक्रम",
      civic_reports: "नागरी अहवाल",
      neighborhood_pulse: "शेजारची स्पंदने",
      weather: "हवामान",
      nature: "निसर्ग",
      marketplace: "बाजारपेठ",
      news: "बातम्या",
      causes: "उद्दिष्टे",
      more: "अधिक",
    },
    header: { sign_in: "साइन इन", join: "Social Pulse मध्ये सामील व्हा", language: "भाषा", search: "शोधा" },
    tagline: "समुदायांना जोडणे · जीवनाला सक्षम करणे · सामाजिक भांडवल तयार करणे",
    locality: {
      viewing_from: "आपण पाहत आहात",
      help_improve: "आपले स्थान सुधारण्यास मदत करा",
      filter_by_country: "देशानुसार फिल्टर करा",
      change: "बदला",
      set_your_location: "आपले स्थान सेट करा",
      set_your_location_hint: "— वैयक्तिकृत करण्यासाठी टॅप करा",
    },
    actions: {
      submit_cause: "एक उद्दिष्ट / विनंती सादर करा",
      make_donation: "Social Pulse च्या जागतिक उपक्रमांना समर्थन द्या — देणगी द्या",
      browse_all: "सर्व विभाग पहा",
    },
    news: {
      title: "आपली दैनंदिन बातमीपत्रिका.",
      submit_news: "बातमी सादर करा",
      archive: "संग्रह",
      weather_nature: "हवामान आणि निसर्ग",
      play_briefing: "दैनंदिन ब्रीफिंग ऐका",
      play_briefing_hint: "शीर्ष {{count}} बातम्या ऐका · ~{{minutes}} मिनिटे · आपल्या भाषेत",
      read_original: "मूळ वाचा",
      view_brief: "सारांश पहा",
      also_reported_by: "यांच्याद्वारे देखील अहवाल:",
      translate: "भाषांतर करा",
      listen: "ऐका",
      stop: "थांबवा",
    },
  },
};
